import { styled, TableRow as MuiTableRow } from "@mui/material";
import {
  sapphire,
  jordyBlue,
  dodgerBlue,
  linkWater,
  supernova,
  white,
  deYork,
  gainsboro,
} from "../../../shared/assets/colors";

const PREFIX = "DebtorGroupMapTableRowStyles";
export const classes = {
  cell: `${PREFIX}-cell`,
  typographyValue: `${PREFIX}-typographyValue`,
  typographyLink: `${PREFIX}-typographyLink`,
  typographyLabel: `${PREFIX}-typographyLabel`,
  buttonIcon: `${PREFIX}-buttonIcon`,
  hoverText: `${PREFIX}-hoverText`,
  defaultChip: `${PREFIX}-defaultChip`,
  greenChip: `${PREFIX}-greenChip`,
  blueChip: `${PREFIX}-blueChip`,
  orangeChip: `${PREFIX}-orangeChip`,
};

export const TableRow = styled(MuiTableRow)(() => ({
  [`& .${classes.cell}`]: {
    border: `1px solid ${gainsboro}`,
  },
  [`& .${classes.typographyValue}`]: {
    color: sapphire,
    textDecoration: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 400,
    whiteSpace: "nowrap",
  },
  [`& .${classes.typographyLink}`]: {
    textDecoration: "none",
  },
  [`& .${classes.typographyLabel}`]: {
    color: linkWater,
    textDecoration: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 400,
    whiteSpace: "nowrap",
  },
  [`& .${classes.buttonIcon}`]: {
    color: jordyBlue,
  },
  [`& .${classes.defaultChip}`]: {
    maxWidth: 90,
    maxHeight: 20,
    fontSize: 10,
  },
  [`& .${classes.greenChip}`]: {
    backgroundColor: deYork,
    color: white,
  },
  [`& .${classes.blueChip}`]: {
    backgroundColor: dodgerBlue,
    color: white,
  },
  [`& .${classes.orangeChip}`]: {
    backgroundColor: supernova,
    color: white,
  },
}));
